<template>
	<div class="report-container">
		<div class="circle-decoration"></div>

		<header class="header-section">
			<h1 class="year-text">2026</h1>
			<h2 class="brand-name">富学宝典</h2>
			<div class="report-badge">八月学习报告</div>
			<p class="slogan">坚持学习的人 · 永葆青春</p>
			<p class="slogan pc-only-hint">(请使用富学宝典APP扫码查看)</p>
		</header>
		<main v-show="false" class="main-content">
			<div class="input-group" :class="{ 'is-focused': isFocused }">
				<input  class="job-input" placeholder="请输入工号" v-model="jobNo" @focus="isFocused = true" @blur="isFocused = false" type="text">
				<div class="input-line"></div>
			</div>
			<button class="submit-btn" @click="debouncedSubmit" :disabled="!jobNo"> 
				<span>LET'S GO</span>
        
				<div class="btn-glow"></div>
			</button>
		</main>

		<footer class="footer-info" v-show="footerVisible">
			<p>版权所有：富泰华工业（深圳）有限公司</p>
			<p>备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a></p>
		</footer>
	</div>
</template>

<script>
import jieliufa from '@/utils/jieliufa'

export default {
	data() {
		return {
			jobNo: '',
			isFocused: false,
			footerVisible: true,
			originalHeight: 0
		}
	},
	computed: {
		// 使用节流包装提交方法
		debouncedSubmit() {
		return jieliufa.throttle(() => {
			this.submitJobNo()
		}, 1000)
		}
	},
	mounted() {
		this.originalHeight = window.innerHeight;
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
		// 兼容移动端键盘弹出遮挡
		this.footerVisible = window.innerHeight >= this.originalHeight - 100;
		},
		submitJobNo() {
		if (!this.jobNo.trim()) {
			this.$message({
			message: "请输入工号",
			type: "warning",
			center: true
			})
			return
		}
		this.$emit('inputJobNo', this.jobNo)
		}
	}
}
</script>

<style scoped>
/* 容器基础样式 */
.report-container {
	position: relative;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	/* 关键修改：使用 linear-gradient 叠加一个半透明黑色层在背景图之上 */
	/* 这里的 rgba(0,0,0,0.4) 表示40%透明度的黑色，如果还是看不清，可以改成 0.5 或 0.6 */
	background: 
		linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
		url("../../assets/26April/logo.png") right top no-repeat,
		url("../../assets/26May/icon.png") 49% calc(80% + 20px) no-repeat,
		url("../../assets/26August/bg.jpg") no-repeat;
	background-size: cover, 110px 35px, 68%, cover;
	background-position: center, right top, 49% calc(80% + 20px), center;
	
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #ffffff; 
}

/* 默认隐藏该提示（针对手机端） */
.pc-only-hint {
  	display: none;
}

/* 头部装饰 */
.header-section {
  margin-top: 15vh;
  text-align: center;
  z-index: 2;
}

.year-text {
  font-size: 56px;
  font-weight: 900;
  color: #008777;
  margin: 0;
  line-height: 1;
  font-family: 'Gentium Basic', serif;
  letter-spacing: 2px;
  /* 增强阴影，增加层次感 */
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.brand-name {
  font-size: 32px;
  color: #008777;
  margin: 10px 0;
  /* 增强阴影 */
  text-shadow: 0 2px 8px rgba(205, 236, 227, 0.5);
}

.report-badge {
  display: inline-block;
  /* 徽章背景保持高亮，形成反差 */
  background: rgba(255, 255, 255, 0.95);
  /* 文字颜色保持紫色，或者改为深色 #333 以增加对比 */
  color: #42a79d; 
  font-weight: 800;
  padding: 6px 24px;
  border-radius: 50px;
  font-size: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  margin: 15px 0;
}

.slogan {
  font-size: 20px;
  /* 标语使用纯白，依靠背景遮罩来凸显 */
  color: #ffffff;
  font-weight: 500;
  letter-spacing: 1px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
}

/* 主体交互区 */
.main-content {
  width: 80%;
  max-width: 320px;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.input-group {
  width: 100%;
  position: relative;
  margin-bottom: 40px;
  transition: all 0.3s ease;
}

.job-input {
  width: 100%;
  border: none;
  /* 输入框背景保持较亮，确保输入内容可见 */
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 12px;
  font-size: 18px;
  text-align: center;
  outline: none;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  color: #333;
}

.job-input::placeholder {
  color: #999;
}

.input-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: #ACD932;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(-50%);
}

.input-group.is-focused .input-line {
  width: 80%;
}

.input-group.is-focused .job-input {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.25);
}

/* 按钮样式 */
.submit-btn {
  position: relative;
  padding: 12px 40px;
  border: none;
  background: #d03327;
  color: #fff;
  border-radius: 12px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 8px 20px rgba(208, 51, 39, 0.5);
}

.submit-btn:active {
  transform: scale(0.95);
}

.submit-btn:disabled {
  background: #ccc;
  box-shadow: none;
  cursor: not-allowed;
  color: #888;
}

.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  transition: 0.5s;
  animation: sweep 3s infinite;
}

@keyframes sweep {
  0% { left: -100%; }
  50% { left: 100%; }
  100% { left: 100%; }
}

/* 页脚 */
.footer-info {
  position: fixed;
  bottom: 20px;
  text-align: center;
  font-size: 12px;
  /* 页脚文字稍微调亮一点，因为背景底部可能较暗 */
  color: #333;
  line-height: 0.8;
  /* text-shadow: 0 1px 2px rgba(0,0,0,0.5); */
}

.footer-info a {
  color: #333;
  text-decoration: none;
  transition: opacity 0.3s;
}

.footer-info a:hover {
  opacity: 0.8;
}

/* 桌面端适配 */
@media screen and (min-width: 1024px) {
  .report-container {
    /* PC端背景同样添加遮罩，防止背景过亮 */
    background:
            url("../../assets/26May/logo.png") right  top  no-repeat,
            url("../../assets/26August/code.png") 50% calc(70% + 10px) no-repeat,
            url("../../assets/26August/pcbg.png")  no-repeat;
    background-size: 110px 35px, 10%,cover;
  }
  .pc-only-hint {
    display: block;
    margin-top: 10px;
    color: #000;
    font-size: 14px;
    opacity: 0.9;
    text-shadow: 0 1px 2px rgba(0,0,0,0.5);
  }
  .report-badge{
    color: #42a79d;
  }
  .slogan {
    color: #ffffff;
  }
  .header-section { margin-top: 10vh; }
  .year-text { font-size: 80px; }
  .brand-name { font-size: 48px; }
  .main-content { max-width: 450px; }
  .job-input { font-size: 24px; }
}
</style>